import meters from './meters';
import service from './service';
import settings from './settings';
import regeneration from './regeneration';
import workflow from './workflow';

const data = {
  ...meters,
  ...service,
  ...settings,
  ...regeneration,
  ...workflow
};

export default data;



// WEBPACK FOOTER //
// ./src/screens/data/flow3/index.js